import { Edit } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Popover } from 'antd'
import { NAMESPACE } from 'locale'
import type React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type MissedMedicationPopoverProps = {
  children: React.ReactNode
  onSignForMissed: () => void
}

const MissedMedicationPopover = ({
  children,
  onSignForMissed
}: MissedMedicationPopoverProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const [open, setOpen] = useState(false)

  const handleSignForMissed = () => {
    setOpen(false)
    onSignForMissed()
  }

  const content = (
    <PopoverContent>
      <PopoverTitle level={2}>{t('MISSED_MEDICATION_FOLLOW_UP')}</PopoverTitle>
      <StyledDivider />
      <ActionItem
        onClick={handleSignForMissed}
        data-testid="missed-popover-sign-btn"
      >
        <Edit />
        <ActionText>{t('SIGN_FOR_MISSED_MEDICATION')}</ActionText>
      </ActionItem>
    </PopoverContent>
  )

  return (
    <Popover
      content={content}
      title={null}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      placement="bottom"
    >
      {children}
    </Popover>
  )
}

const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 240px;
`

const PopoverTitle = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const StyledDivider = styled(Divider)`
  margin: 12px 0;
`

const ActionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 6px;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.color.neutral.color3};
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.neutral.color9};
  }
`

const ActionText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default MissedMedicationPopover
